import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';

export const SearchStringWrapper = styled(SmallText)`
  padding: 0 ${({ theme }) => theme.spacing(1)};
`;

export const SearchStringValue = styled(SmallText)`
  display: inline;
`;

export const AddressSuggestion = styled.div<{ isActive: boolean; combinedFiltersSearchMode?: boolean }>`
  ${({ theme, isActive, combinedFiltersSearchMode }) => `
    margin-bottom: ${theme.spacing(1)};
    padding-left: ${theme.spacing(1)};
    padding-right: ${theme.spacing(1)};
    background: ${isActive ? theme.colors.neutrals.grey10 : theme.colors.neutrals.white};
    color: ${theme.colors.neutrals.grey1};
    border-radius: ${theme.borderRadius.tiny};
    svg {
      margin-left: ${theme.spacing(1)};
      min-width: 24px;
    }
    span {
      color: ${combinedFiltersSearchMode ? theme.colors.neutrals.grey1 : theme.colors.brand.main};
      font-weight: ${combinedFiltersSearchMode ? 700 : 400};
    }
  `}
  &:last-of-type {
    margin: 0;
  }
  height: 40px;
  width: 100%;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

export const IconSuggestion = styled.div`
  display: inline-block;
  position: relative;
`;

export const AddressSuggestionText = styled(Text)`
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
`;

export const CompletionTypeText = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey4};
    padding-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(.5)};
  `}
  text-transform: capitalize;
  display: inline;
  &::before {
    content: '· ';
  }
`;

export const SuggestionTitleWrapper = styled(SmallText)<{ isFirst: boolean }>`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-top: ${({ theme, isFirst }) => isFirst ? 0 : theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;
